import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context/src/app-context';
import { IconInfoOutlined } from '@prisjakt/ui/icon';
import { FontEmphasis } from '@prisjakt/ui/text';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { ProductPriceType } from 'src/areas/product/types';
import * as S from './styles';

interface IPriceTypeNoticeBadge {
  priceType?: ProductPriceType | null;
}

export const PriceTypeNoticeBadge: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceTypeNoticeBadge>
>> = props => {
  const { t } = useAppContext();

  const { priceType } = props;

  const isUnusualPriceType =
    priceType &&
    priceType !== ProductPriceType.NORMAL &&
    priceType !== ProductPriceType.USED_PRODUCT &&
    priceType !== ProductPriceType.NOT_IN_MINT_CONDITION;

  if (!isUnusualPriceType) {
    return null;
  }
  const label = t(
    'product',
    `price-notice.${priceType}` as keyof ParamsAndReturnTypes['product']
  );

  return (
    <S.PriceInfoElement>
      <Tooltip
        placement={TooltipPlacement.TOP}
        title={label as string}
        renderOnMouseOver
      >
        <S.IconWrapper>
          <IconInfoOutlined color="base300" />
        </S.IconWrapper>
      </Tooltip>
      <CaptionText emphasis={FontEmphasis.MEDIUM}>
        {label as string}
      </CaptionText>
    </S.PriceInfoElement>
  );
};
